import React, {useState, useEffect, useRef , useContext } from 'react';
import { Table, Form, Input, Row, Col, Button, message, InputNumber, Space } from 'antd';
import { DeleteOutlined } from '@ant-design/icons';

const EditableContext = React.createContext(null);

const participantsColEdit = [
    {
      title: 'Nome',
      dataIndex: 'playerName',
      key: 'name', 
      editable: false,
      render: (state, record) => (<span>{record.playerName} {record.playerSurname}</span>) 
    },
/*     {
      title: 'Nome',
      dataIndex: 'playerName',
      key: 'name', 
    },
    {
      title: 'Cognome',
      dataIndex: 'playerSurname',
      key: 'surname',
    }, */
  ];

function WaitlistTable(props) {
    const [dataSource, setDataSource] = useState(props.dataSource)
    const [messageApi, contextHolder] = message.useMessage();
    // console.warn('props di rankingtable', props)
    let participantsCol;
    if (props.admin) {
      participantsCol = [
          {
            title: 'Nome',
            dataIndex: 'playerName',
            key: 'name', 
            editable: false,
            render: (state, record) => (<span>{record.playerName} {record.playerSurname}</span>) 
          },
          {
            title: 'Mazzo',
            dataIndex: 'deckName',
            key: 'deckName',
            editable: true,
          },
      /*     {
            title: 'Cognome',
            dataIndex: 'playerSurname',
            key: 'surname',
          }, */
          {
            title: 'Azioni',
            dataIndex: 'playerId',
            key: 'playerId',
            render: (state, record) => ((<Space><Button icon={<DeleteOutlined />} onClick={() => onDeletePlayer(record)}/>
              </Space>))
          }
      ];
    } else {
      participantsCol = [
        {
          title: 'Nome',
          dataIndex: 'playerName',
          key: 'name', 
          editable: false,
          render: (state, record) => (<span>{record.playerName} {record.playerSurname}</span>) 
        },
      ];
    }

    useEffect(() => {
        setDataSource(props.dataSource)
    }, [props.dataSource])

    async function onDeletePlayer(participant) {
      // console.warn('arrivato alla chiamata ajax! ', participant)
      try {
        await new Promise((resolve, reject) => props.removePlayer(resolve,reject, participant ));
        messageApi.success(`Giocatore rimosso!`);
        window.location.reload(false);
      } catch (error) {
        // console.warn('errore upload! ', error.message);
        let cause;
        if (error.message.toLowerCase().includes('credentials')) {
            cause = 'La sessione sembra essere scaduta, autenticarsi nuovamente al CAS';
        }
        messageApi.error(`Giocatore non rimosso! Errore:
        ${cause}`);
        return;
      }
    }

    async function onSave(event) {
        event.preventDefault()
        // alert("salvo la classifica!")
        // console.warn('params di rankingtable', stageId)
        try {
            await new Promise((resolve, reject) =>
            props.setRanking(resolve,reject, props.stage.value.payLoad.id, dataSource));
            messageApi.success(`Classifica aggiornata correttamente!`);
            // props.drawerToggle(false);
            // setLoading(false);
        } catch (error) {
            // console.warn('errore upload! ', error.message);
            let cause;
            if (error.message.toLowerCase().includes('credentials')) {
                cause = 'La sessione sembra essere scaduta, autenticarsi nuovamente.';
            }
            messageApi.error(`Classifica non aggiornata, qualcosa è andato storto:
            ${cause}`);
            // setLoading(false);
            return;
        }
    }

    const handleSave = (row) => {
        // console.warn('riga modificata:',row)
        const newData = [...dataSource];
        const index = newData.findIndex((item) => row.playerId === item.playerId);
        const item = newData[index];
        newData.splice(index, 1, { ...item, ...row });
        setDataSource(newData);
      };

    if (props.editing === false) {
        return (
            <Table 
            size="small" 
            columns={participantsCol}
            dataSource={dataSource}
            pagination={false}
            loading={props.waitlist && !props.waitlist.fulfilled && props.waitlist.pending}
            title={() => 'Waiting List'}
          />
        )
    } else {
        const EditableRow = ({ index, ...props }) => {
            const [form] = Form.useForm();
            return (
              <Form form={form} component={false}>
                <EditableContext.Provider value={form}>
                  <tr {...props} />
                </EditableContext.Provider>
              </Form>
            );
          };
          
          const EditableCell = ({
            title,
            editable,
            inputType,
            children,
            dataIndex,
            record,
            handleSave,
            ...restProps
          }) => {
            const [editing, setEditing] = useState(false);
            const inputRef = useRef(null);
            const form = useContext(EditableContext);
            useEffect(() => {
              if (editing) {
                inputRef.current.focus();
              }
            }, [editing]);
          
            const toggleEdit = () => {
              setEditing(!editing);
              form.setFieldsValue({
                [dataIndex]: record[dataIndex],
              });
            };
          
            const save = async () => {
              try {
                const values = await form.validateFields();
                toggleEdit();
                handleSave({ ...record, ...values });
              } catch (errInfo) {
                console.log('Save failed:', errInfo);
              }
            };
          
            let childNode = children;
          
            if (editable) {
              /* childNode = editing ? (
                <Form.Item
                  style={{
                    margin: 0,
                  }}
                  name={dataIndex}
                  rules={[
                    {
                      required: true,
                      message: `${title} is required.`,
                    },
                  ]}
                >
                  <InputNumber ref={inputRef} onPressEnter={save} onBlur={save} />
                </Form.Item>
              ) : (
                <div
                  className="editable-cell-value-wrap"
                  style={{
                    paddingRight: 24,
                  }}
                  onClick={toggleEdit}
                >
                  {children}
                </div>
              ); */

              if (editing) {
                if (inputType === 'number') {
                  childNode = (
                    <Form.Item
                      style={{
                        margin: 0,
                      }}
                      name={dataIndex}
                      rules={[
                        {
                          required: true,
                          message: `${title} is required.`,
                        },
                      ]}
                    >
                      <InputNumber ref={inputRef} onPressEnter={save} onBlur={save} />
                    </Form.Item>
                  );
                } else {
                  childNode = (
                    <Form.Item
                      style={{
                        margin: 0,
                      }}
                      name={dataIndex}
                      rules={[
                        {
                          required: true,
                          message: `${title} is required.`,
                        },
                      ]}
                    >
                      <Input ref={inputRef} onPressEnter={save} onBlur={save} />
                    </Form.Item>
                  );
                }
              } else {
                childNode = (
                  <div
                    className="editable-cell-value-wrap"
                    style={{
                      paddingRight: 24,
                    }}
                    onClick={toggleEdit}
                  >
                    {children}
                  </div>
                );
              }
            }
          
            return <td {...restProps}>{childNode}</td>;
          };

          const components = {
            body: {
              row: EditableRow,
              cell: EditableCell,
            },
          };

          const columns = participantsColEdit.map((col) => {
            if (!col.editable) {
              return col;
            }
        
            return {
              ...col,
              onCell: (record) => ({
                record,
                editable: col.editable,
                inputType: col.inputType,
                dataIndex: col.dataIndex,
                title: col.title,
                handleSave,
              }),
            };
          });
        return (
            <>
              {contextHolder}
                <Row justify="center" style={{ marginBottom: '10px' }}>
                    <Col span={4}><Button type="primary" danger onClick={props.toggleEditing}>Annulla</Button></Col>
                    <Col span={4}><Button onClick={(event) => onSave(event)}>Salva</Button></Col>
                </Row>
                <Table
                    components={components}
                    rowClassName={() => 'editable-row'}
                    dataSource={dataSource}
                    columns={columns}
                    pagination={false}
                />
            </>
            
        )
    }
}

export default WaitlistTable;